module.exports = __webpack_public_path__ + "img/equipement.c3125631.png";